import * as Sentry from '@sentry/browser'

/** Send error to Sentry. Logs the stacktrace on console if running on dev environment.
 * If a custom message is omitted, shows the exception message on the toast.
 * @err the exception object
 * @contextName a string with the context name of the error
 * @extra args to be send in context data
 */
export const reportError = (err, contextName = 'error', ...extra) => {
  if (process.env.NODE_ENV === 'development') {
    console.error(err)
  }
  else {
    Sentry.captureException(err, { contexts: { [contextName]: extra } })
  }
}

/** Send error message to Sentry. Logs it on console if running on dev environment.
 * @message  custom error message
 * @contextName a string with the context name of the error
 * @extra args to be send in context data
 */
export const reportErrorMessage = (message, contextName = 'error', ...extra) => {
  if (process.env.NODE_ENV === 'development') {
    console.error(message)
  }
  else {
    Sentry.captureMessage(message, { contexts: { [contextName]: extra } })
  }
}
